export default __webpack_public_path__ + "static/media/Socket-io-01.ba5a13c8.svg";